import React, { useState, useRef } from "react";
import { Container, Row, Col, Form, Button, Alert } from "react-bootstrap";
import Particle from "../Particle";
import emailjs from "@emailjs/browser";

function Contact() {
  const formRef = useRef();
  const [formData, setFormData] = useState({
    from_name: "",
    from_email: "",
    subject: "",
    message: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertType, setAlertType] = useState("success");

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setShowAlert(false);

    try {
      // Get EmailJS credentials from environment variables
      // See EMAILJS_SETUP.md for setup instructions
      const serviceId = process.env.REACT_APP_EMAILJS_SERVICE_ID || "YOUR_SERVICE_ID";
      const templateId = process.env.REACT_APP_EMAILJS_TEMPLATE_ID || "YOUR_TEMPLATE_ID";
      const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY || "YOUR_PUBLIC_KEY";

      // Check if EmailJS is configured
      if (serviceId === "YOUR_SERVICE_ID" || templateId === "YOUR_TEMPLATE_ID" || publicKey === "YOUR_PUBLIC_KEY") {
        throw new Error("EmailJS is not configured. Please set up your credentials. See EMAILJS_SETUP.md for instructions.");
      }

      await emailjs.sendForm(
        serviceId,
        templateId,
        formRef.current,
        publicKey
      );

      setAlertMessage("Message sent successfully! I'll get back to you soon.");
      setAlertType("success");
      setShowAlert(true);
      
      // Reset form
      setFormData({
        from_name: "",
        from_email: "",
        subject: "",
        message: "",
      });
    } catch (error) {
      console.error("EmailJS error:", error);
      setAlertMessage("Failed to send message. Please try again or contact me directly via email.");
      setAlertType("danger");
      setShowAlert(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Container fluid className="project-section" style={{ position: "relative" }}>
      <Particle />
      <Container style={{ position: "relative", zIndex: 1 }}>
        <h1 className="project-heading">
          Get In <strong className="purple">Touch</strong>
        </h1>
        <p style={{ color: "white" }}>
          Have a project in mind or want to collaborate? Feel free to reach out!
        </p>
        
        {showAlert && (
          <Row style={{ justifyContent: "center", paddingBottom: "20px" }}>
            <Col md={8}>
              <Alert variant={alertType} onClose={() => setShowAlert(false)} dismissible>
                {alertMessage}
              </Alert>
            </Col>
          </Row>
        )}

        <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
          <Col md={8}>
            <Form ref={formRef} onSubmit={handleSubmit} className="contact-form" style={{ position: "relative", zIndex: 2 }}>
              <Form.Group className="mb-3" controlId="formName">
                <Form.Label style={{ color: "white", textAlign: "left", display: "block" }}>Name</Form.Label>
                <Form.Control
                  type="text"
                  name="from_name"
                  placeholder="Your Name"
                  value={formData.from_name}
                  onChange={handleChange}
                  required
                  style={{
                    backgroundColor: "rgba(255, 255, 255, 0.1)",
                    border: "1px solid rgba(255, 255, 255, 0.3)",
                    color: "white",
                    position: "relative",
                    zIndex: 3,
                  }}
                />
              </Form.Group>

              <Form.Group className="mb-3" controlId="formEmail">
                <Form.Label style={{ color: "white", textAlign: "left", display: "block" }}>Email</Form.Label>
                <Form.Control
                  type="email"
                  name="from_email"
                  placeholder="your.email@example.com"
                  value={formData.from_email}
                  onChange={handleChange}
                  required
                  style={{
                    backgroundColor: "rgba(255, 255, 255, 0.1)",
                    border: "1px solid rgba(255, 255, 255, 0.3)",
                    color: "white",
                    position: "relative",
                    zIndex: 3,
                  }}
                />
              </Form.Group>

              <Form.Group className="mb-3" controlId="formSubject">
                <Form.Label style={{ color: "white", textAlign: "left", display: "block" }}>Subject</Form.Label>
                <Form.Control
                  type="text"
                  name="subject"
                  placeholder="What's this about?"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                  style={{
                    backgroundColor: "rgba(255, 255, 255, 0.1)",
                    border: "1px solid rgba(255, 255, 255, 0.3)",
                    color: "white",
                    position: "relative",
                    zIndex: 3,
                  }}
                />
              </Form.Group>

              <Form.Group className="mb-3" controlId="formMessage">
                <Form.Label style={{ color: "white", textAlign: "left", display: "block" }}>Message</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={6}
                  name="message"
                  placeholder="Tell me about your project or inquiry..."
                  value={formData.message}
                  onChange={handleChange}
                  required
                  style={{
                    backgroundColor: "rgba(255, 255, 255, 0.1)",
                    border: "1px solid rgba(255, 255, 255, 0.3)",
                    color: "white",
                    position: "relative",
                    zIndex: 3,
                  }}
                />
              </Form.Group>

              <Button
                className="contact-submit-button"
                variant="primary"
                type="submit"
                disabled={isSubmitting}
                style={{
                  backgroundColor: "var(--imp-text-color)",
                  borderColor: "var(--imp-text-color)",
                  padding: "10px 30px",
                  fontSize: "1.1em",
                  position: "relative",
                  zIndex: 3,
                  cursor: isSubmitting ? "not-allowed" : "pointer",
                }}
              >
                {isSubmitting ? "Sending..." : "Send Message"}
              </Button>
            </Form>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Contact;


